import { ActionDropdown, useConfirm } from '@genial/components';
import { Color } from '@genial/design-tokens';
import { RouteProp, useRoute } from '@react-navigation/native';
import { Button } from 'native-base';
import React from 'react';

import { CustomerDetailStackParamList } from '../../../../../routes/types';

interface ExportDropdownProps {
  isExporting: boolean;
  isDisabled: boolean;
  onDownload: () => void;
  onSendToClient: () => void;
}

export const ExportPdfDropdown: React.FC<ExportDropdownProps> = ({
  isExporting,
  isDisabled,
  onDownload,
  onSendToClient,
}) => {
  const { params } = useRoute<RouteProp<CustomerDetailStackParamList, 'CustomerDetail'>>();

  const accountNumber = params?.accountNumber;
  const { confirm } = useConfirm();

  if (isExporting) {
    return (
      <Button
        variant="textLink"
        isLoading
        spinnerPlacement="end"
        isLoadingText="COMPARTILHAR"
        _text={{
          color: 'brand.tertiary.principal',
          fontWeight: 'semibold',
        }}
      />
    );
  }

  const handleSendToClient = () => {
    confirm(
      {
        title: 'Atenção',
        icon: 'Warning',
        iconColor: 'feedback.attention.default',
        confirmText: 'Confirmar',
        cancelText: 'Voltar',
        confirmColor: 'feedback.error.default',
        description: `Confirma o envio do email com o extrato de ${accountNumber} para o cliente?`,
      },
      () => onSendToClient()
    );
  };

  return (
    <ActionDropdown
      triggerLabel="COMPARTILHAR"
      triggerLabelColor={isDisabled ? 'neutral.light' : 'brand.tertiary.principal'}
      triggerIcon="Share"
      triggerIconProps={{
        size: 'sm',
        color: Color[isDisabled ? 'neutral.light' : 'brand.tertiary.principal'],
      }}
      triggerProps={{ isDisabled }}
      triggerIconReplacesDropdownIcon
      placement="bottom right">
      <ActionDropdown.Item label="EXPORTAR EM PDF" onPress={onDownload} />
      <ActionDropdown.Item label="ENVIAR PARA O CLIENTE" onPress={handleSendToClient} />
    </ActionDropdown>
  );
};
